<img [src]="payload.img" (error)="close()" />
